import { MOSIDA_API_BASE_URL } from "./mosidaApi";
import {
  DEFAULT_PROCESSING_FEE_PERCENT,
  DEFAULT_SALES_TAX_PERCENT,
  getMuseumFeeTaxPercents,
} from "./museumFeeTax";

const currentMuseumUrl = `${MOSIDA_API_BASE_URL}/museums/current`;

function extractMuseumRecord(payload) {
  if (!payload || typeof payload !== "object") return null;

  const root = payload;
  if (
    root.processingFeePercent != null ||
    root.salesTaxPercent != null ||
    root.processing_fee_percent != null ||
    root.sales_tax_percent != null
  ) {
    return root;
  }

  const data = root.data;
  if (data && typeof data === "object") {
    return data;
  }

  return root;
}

export function parseMuseumFeeTaxSettings(payload) {
  return getMuseumFeeTaxPercents(extractMuseumRecord(payload));
}

/**
 * Fetch museum fee/tax from GET /museums/current.
 * @returns {{ success: boolean, data: { processingFeePercent: number, salesTaxPercent: number }, error?: string }}
 */
export async function fetchMuseumFeeTaxSettings() {
  const defaults = {
    processingFeePercent: DEFAULT_PROCESSING_FEE_PERCENT,
    salesTaxPercent: DEFAULT_SALES_TAX_PERCENT,
  };

  try {
    const response = await fetch(currentMuseumUrl, {
      method: "GET",
      headers: { accept: "*/*" },
    });

    if (!response.ok) {
      const errorText = await response.text();
      return {
        success: false,
        data: defaults,
        error:
          errorText ||
          `Failed to load museum fee/tax (${response.status})`,
      };
    }

    const json = await response.json();
    const data = parseMuseumFeeTaxSettings(json);
    return { success: true, data };
  } catch (error) {
    console.warn(
      "[museumService] Failed to load museum fee/tax:",
      error?.message || error
    );
    return {
      success: false,
      data: defaults,
      error: error?.message || "Network error while loading museum fee/tax",
    };
  }
}
